// extracted by mini-css-extract-plugin
export default {"root":"CustomWeekDays_root__EiQXe","day":"CustomWeekDays_day__U5BD4","selected":"CustomWeekDays_selected__sauAH","disabled":"CustomWeekDays_disabled__Cqztu"};